export default "{{>fileUploadArea.hbs model='backgroundUpload' id=\"backgroundUpload\" }}\n";